import {Typography} from '@mui/material';
import {Stack} from '@mui/system';
import {IconIllustration, StyledCard} from 'presentation/components';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getOnlyFirstWord} from 'presentation/utils';
import React from 'react';

const {businessAccessCard} = translations['pt-br'].privateFlow.home;

function BusinessAccessCard() {
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const formattedBeneficiary = getOnlyFirstWord(formatText(nmSocialUsuarioC || nmUsuarioC));

	return (
		<StyledCard.Container
			sx={{
				display: 'flex',
				alignItems: 'start',
				gap: '12px',
			}}>
			<Stack flex={1} flexDirection={'row'} alignItems={'start'} gap={'12px'}>
				<Typography
					variant="body2"
					component={'span'}
					color="text.primary"
					fontSize={'1rem'}>
					{businessAccessCard.line1}
					<b>{formattedBeneficiary}</b>
					{businessAccessCard.line2}
				</Typography>
				<IconIllustration variant="primary" size="small" customIconName="computer-filled" />
			</Stack>
		</StyledCard.Container>
	);
}

export default BusinessAccessCard;
